import { createApp } from 'vue'

import InfiniteLoading from 'v3-infinite-loading'
import { vue3Debounce } from 'vue-debounce'
import { mask } from 'vue-the-mask'
import { registerPlugins } from '@core/utils/plugins'
import App from '@/App.vue'
import { initSessionMonitoring } from '@/utils/sessionManager'

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'
import 'v3-infinite-loading/lib/style.css'

// Create vue app
const app = createApp(App) // required if you're not going to override default slots

// Use components
app.component('InfiniteLoading', InfiniteLoading)

// Use directives
app.directive('mask', mask)
app.directive('debounce', vue3Debounce({ lock: true }))

// Register plugins
registerPlugins(app)

// Inicializa o monitoramento de sessão
initSessionMonitoring()

// Mount vue app
app.mount('#app')
